import {ViewAccess} from "../../../../../../../core/gd/const/views/view-type-config"
import ApiProject from "../../../../../../../core/gd/api/project"
import CustomView from "../../../../../../../core/model2/custom-view/custom-view"

// const debug = "quickAdd_submitData"
const debug = false

export default async function quickAdd_submitData(view: CustomView, formData: any) {
    const name = formData.name

    const sharedUsers   = formData.sharedUsers
    let access          = formData.access
    switch (formData.access) {
        case ViewAccess.PRIVATE:
            // do nothing, already private
            break

        case ViewAccess.SHARED:
            // set access to private if no shared users selected
            if (sharedUsers.length === 0) access = ViewAccess.PRIVATE
            break
    }

    const params: any = {}
    if (formData && formData.location) {
        params.location = formData.location
    }

    if (view.inProjectStructure) {
        debug && console.log(debug, "create view in projects structure", view)

        const parentProject = gd.session.projects.get(view.parentProjectId)!

        const response : any = await ApiProject.newView({
            name            : name,
            color           : parentProject.color,
            parentProjectId : view.parentProjectId,
            projectIcon     : view.projectIcon,
            settings        : {
                customView      : {
                    settings        : formData.settings,
                    type            : view.type
                }
            }
        }).promise()

        debug && console.log(debug, "project view created", response)

        gd.quickAdd.close()
        gd.navigation.goToProject(response.projectId)
        return
    }

    return await gd.api.Views.create(view.type, name, params, access, sharedUsers, formData.settings).promise()
}